import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { computed, ref, h } from 'vue'
import BaseGroupItem from '@teams/common/components/groupList/baseGroupItem.vue'
import { DropdownMixedOption } from 'naive-ui/es/dropdown/src/interface'
import useContextMenu from '../contextMenu/useContextMenu'
import Icon from '@teams/common/components/icon'
import { useMessage } from 'naive-ui'
import { useAppDialog } from '@/components/appDialog'
import { Auth, useGroupStore } from '@teams/common/store/group'
import usePreference from '@teams/common/hooks/usePreference'
import commonConfirmDialog from '@/components/dialog/commonConfirmDialog.vue'
import handleResponseError from '@teams/common/hooks/useResponseError'
import { useAccountChange } from '@teams/common/hooks/useAccountChange'


export default /*#__PURE__*/_defineComponent({
  __name: 'groupItem',
  props: {
    id: null,
    name: null,
    avatar: null,
    isSelect: { type: Boolean },
    groupItemSourceType: null,
    stickyTop: { type: Boolean },
    auth: null,
    spaceType: null
  },
  setup(__props: any) {

const props = __props as {
  id: number
  name: string
  avatar: string
  isSelect: boolean
  groupItemSourceType: 'mine' | 'star' | 'latest'
  stickyTop?: boolean
  auth: Auth
  spaceType?: 'company' | 'personal' | 'personal_not_dissolve'
}

const message = useMessage()
const appDialog = useAppDialog()
const { updateMultiState } = useAccountChange()
const { show: showContextMenu, close: closeContextMenu } = useContextMenu()
const isShowMenu = ref(false)

const baseItemRef = ref<{
  enterGroup: () => void
  starGroup: () => Promise<void>
  removeStarGroup: () => Promise<void>
  stickyTopGroup: () => Promise<void>
  removeStickyTopGroup: () => Promise<void>
  exitGroup: () => Promise<void>
  deleteGroup: () => Promise<void>
  changeOwner: (userId: number) => Promise<void>
  isStar: boolean
}>()

const enterGroup = () => {
  const preference = usePreference()
  const groupStore = useGroupStore()
  if (props.id === groupStore.groupId) {
    message.info('正在浏览该空间', {
      icon: () =>
        h(Icon, {
          name: 'info',
          size: '20'
        })
    })
  } else if (preference.hasUnsaved()) {
    appDialog.show({
      component: commonConfirmDialog,
      title: '保存界面效果',
      componentProps: {
        content: '界面效果已产生更改，是否放弃这些更改？',
        confirmButtonText: '确认保存',
        confirmButtonType: 'primary',
        cancelButtonText: '不保存',
        onOK: async () => {
          await preference.save()
          baseItemRef.value?.enterGroup()
          // 切换空间时关闭账号变更提示
          updateMultiState('isChangeAccount', false)
        },
        onCancel: () => {
          baseItemRef.value?.enterGroup()
          // 切换空间时关闭账号变更提示
          updateMultiState('isChangeAccount', false)
        }
      },
      footer: false,
      modalProps: {
        style: {
          width: '480px'
        }
      }
    })
  } else {
    baseItemRef.value?.enterGroup()
    // 切换空间时关闭账号变更提示
    updateMultiState('isChangeAccount', false)
  }
}

const moreIcon = () => {
  const icon = h(Icon, {
    name: 'memberMoreOpt'
  })
  return icon
}

const options = computed(
  () =>
    [
      {
        label: '访问空间',
        key: 'enter',
        props: {
          onClick: () => {
            enterGroup()
          }
        }
      },
      {
        type: 'divider',
        key: 'd1',
        filter: props.groupItemSourceType === 'mine'
      },
      {
        label: '置顶',
        key: 'top',
        props: {
          onClick: () => {
            baseItemRef.value
              ?.stickyTopGroup()
              .then(() => {
                message.success('置顶成功')
              })
              .catch(e => {
                message.error(`置顶失败，${e.message}`)
              })
          }
        },
        filter: props.groupItemSourceType === 'mine' && !props.stickyTop
      },
      {
        label: '取消置顶',
        key: 'unstickyTop',
        props: {
          onClick: () => {
            baseItemRef.value
              ?.removeStickyTopGroup()
              .then(() => {
                message.success('取消置顶成功')
              })
              .catch(() => {
                message.error('取消置顶失败')
              })
          }
        },
        filter: props.groupItemSourceType === 'mine' && !!props.stickyTop
      },
      {
        label: '添加星标',
        key: 'star',
        props: {
          onClick: () => {
            baseItemRef.value
              ?.starGroup()
              .then(() => {
                message.success('添加星标成功')
              })
              .catch(() => {
                message.error('添加星标失败')
              })
          }
        },
        filter: !baseItemRef.value?.isStar
      },
      {
        label: '取消星标',
        key: 'star',
        props: {
          onClick: () => {
            baseItemRef.value?.removeStarGroup()
            message.success('取消星标成功')
          }
        },
        filter: baseItemRef.value?.isStar
      },
      {
        type: 'divider',
        key: 'd2',
        filter: props.groupItemSourceType === 'mine'
      },
      {
        label: '退出空间',
        key: 'exit',
        props: {
          class: 'special-color',
          onClick: () => {
            appDialog.show({
              name: 'ExitTeam',
              componentProps: {
                name: props.name,
                type: props.auth,
                spaceType: props.spaceType,
                gid: props.id
              },
              componentEvents: {
                exitGroup: () => {
                  baseItemRef.value
                    ?.exitGroup()
                    .then(() => {
                      message.success('退出空间成功')
                    })
                    .catch(e => {
                      handleResponseError(e)
                    })
                },
                deleteGroup: () => {
                  baseItemRef.value
                    ?.deleteGroup()
                    .then(() => {
                      message.success('解散空间成功', {
                        duration: 2000,
                        onAfterLeave: () => {
                          // TODO: 解散后空间依旧能正常显示 需要服务端支持
                          // 解散后刷新
                          // window.location.reload()
                        }
                      })
                    })
                    .catch(e => {
                      handleResponseError(e)
                    })
                },
                changeOwner: (userId: number) => {
                  baseItemRef.value
                    ?.changeOwner(userId)
                    .then(() => {
                      message.success('转让空间成功')
                    })
                    .catch(e => {
                      handleResponseError(e)
                    })
                }
              },
              modalProps: {
                style: {
                  width: '480px'
                }
              }
            })
          }
        },
        filter: props.auth !== 'guest'
      }
    ]
      .filter(({ filter }) => (filter === undefined ? true : filter))
      .map(item => ({ ...item, filter: undefined })) as DropdownMixedOption[]
)

const handleSelect = () => {
  closeContextMenu()
  isShowMenu.value = false
}
const handleContextMenu = (e: MouseEvent) => {
  isShowMenu.value = true
  showContextMenu({
    menus: options.value,
    x: e.clientX,
    y: e.clientY,
    onSelect: handleSelect
  })
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(BaseGroupItem, {
    name: __props.name,
    id: __props.id,
    "is-select": __props.isSelect,
    avatar: __props.avatar,
    "group-item-source-type": __props.groupItemSourceType,
    ref_key: "baseItemRef",
    ref: baseItemRef,
    onContextMenu: handleContextMenu,
    "sticky-top": !!__props.stickyTop,
    "more-icon": moreIcon,
    isShowMenu: isShowMenu.value,
    "space-type": __props.spaceType,
    onClick: enterGroup
  }, null, 8, ["name", "id", "is-select", "avatar", "group-item-source-type", "sticky-top", "isShowMenu", "space-type"]))
}
}

})